<lib-card>
  <lib-card-header>
    <div class="p-2 d-flex justify-content-between">
      <h6 class="font-weight-bold text-primary d-flex font-size-medium-small">
        {{title | translate}}
      </h6>
      @if (myQueriesView) {
        <div>
          <lib-select
            id="overview-component-select-option"
            [options]="['Time Series', 'Scatter Plot']"
            [classes]="'text-primary text-left font-size-small cursor-pointer'"
            [itemClasses]="'font-size-small'"
            [withIcon]="true"
            [arrowColor]="'text-tertiary'"
            [placement]="'bottom left'"
            [showCaret]="false"
            [inactiveOptionClasses]="''"
            [doNotTranslate]="true"
            [container]="''"
            (selectedChanged)="addNewQuery($event)">
            <ng-container icon>
              <lib-button
                id="data-analysis-add-button"
                [label]="'+ Add New Query'">
              </lib-button>
            </ng-container>
          </lib-select>
        </div>
      }
    </div>
    <div class="my-3">
      <lib-search
        width="100%"
        placeholder="DATA_STUDIO.DATA_ANALYSIS.SEARCH_FOR_TITLE"
        [value]="searchQueryTitle"
        (inputChanged)="searchTitle($event)">
      </lib-search>
    </div>
  </lib-card-header>
  <lib-card-body [fullContent]="true">
    @if (!dataSource?.length || loading) {
      <app-loading-and-no-data-template
        [isLoading]="loading"
      ></app-loading-and-no-data-template>
    }

    @if (dataSource?.length && !loading) {
      <table mat-table [dataSource]="dataSource" class="all-queries-table w-100">
        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef class="text-start"> {{ "DATA_STUDIO.DATA_ANALYSIS.ID" |translate }} </th>
          <td mat-cell *matCellDef="let element" class="text-start"> #{{element.queryNumber}} </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef class="title-header"> {{ "DATA_STUDIO.DATA_ANALYSIS.QUERY_TITLE" |translate }} </th>
          <td mat-cell *matCellDef="let element">
            <lib-button
              id="data-analysis-view-details"
              [label]="element.title"
              class="mr-2 modify-button"
              [fontSize]="18"
              [align]="'left'"
              [color]="'primary-link'"
              (click)="viewDetails(element, 0)" >
            </lib-button>
          </td>
        </ng-container>
        <ng-container matColumnDef="sites">
          <th mat-header-cell *matHeaderCellDef> {{ "COMMON.PARKS" |translate }} </th>
          <td mat-cell *matCellDef="let element" class="pr-3"> {{element.sites}} </td>
        </ng-container>
        <ng-container matColumnDef="assets">
          <th mat-header-cell *matHeaderCellDef> {{ "COMMON.ASSETS" |translate }} </th>
          <td mat-cell *matCellDef="let element" class="pr-3"> {{element.assets}} </td>
        </ng-container>
        <ng-container matColumnDef="queryType">
          <th mat-header-cell *matHeaderCellDef> {{ "COMMON.TYPE" |translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.queryType === 'TIMESERIES' ? 'Time Series' : 'Scatter Plot'}} </td>
        </ng-container>
        <ng-container matColumnDef="period">
          <th mat-header-cell *matHeaderCellDef> {{ "COMMON.PERIOD" |translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.period}} </td>
        </ng-container>
        <ng-container matColumnDef="series">
          <th mat-header-cell *matHeaderCellDef> {{ "DATA_STUDIO.DATA_ANALYSIS.SERIES" |translate }} </th>
          <td mat-cell *matCellDef="let element"> {{element.numberOfSeries}} </td>
        </ng-container>
        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef class="border-left actions-cell">
            {{ "DATA_STUDIO.PREVIEW.ACTIONS" |translate }}
          </th>
          <td mat-cell *matCellDef="let element" class="border-left">
            <div class="d-flex justify-content-center">
              <div class="action-icon pr-2 pt-1 pointer">
                <div class="icon d-flex justify-content-center align-items-center" (click)="viewDetails(element, 0)" [matTooltip]="'DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.OPEN_CHART' | translate">
                  <img [src]="('icon-chartview' | imageSrc | async)" alt="icon">
                </div>
              </div>
              <div class="action-icon pr-2 pt-1 pointer">
                <div class="icon d-flex justify-content-center align-items-center" (click)="viewDetails(element, 1)" [matTooltip]="'DATA_STUDIO.DATA_ANALYSIS.ALL_QUERIES_VIEW.OPEN_TABLE' | translate">
                  <img [src]="('icon-tableview' | imageSrc | async)" alt="icon">
                </div>
              </div>
              <div class="pt-1">
                <lib-select
                  id="overview-component-select-option"
                  [options]="setOptions(element)"
                  [classes]="'text-primary text-left font-size-normal cursor-pointer'"
                  [withIcon]="true"
                  [arrowColor]="'text-tertiary'"
                  [placement]="'bottom left'"
                  [showCaret]="false"
                  [inactiveOptionClasses]="''"
                  [container]="'body'"
                  (selectedChanged)="action($event, element)">
                  <ng-container icon>
                    <i class="far fa-ellipsis-h font-icons pointer"></i>
                  </ng-container>
                </lib-select>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    }
    <mat-paginator
      [pageSizeOptions]="[10, 20, 50]"
      showFirstLastButtons
      [length]="total"
      (page)="pageChange($event)">
    </mat-paginator>
  </lib-card-body>
</lib-card>

<ng-template #warningDeleteQuery>
  <div class="modal-header d-flex justify-content-between">
    <h6 class="modal-title pull-left font-weight-bold text-primary">{{ 'DATA_STUDIO.DATA_ANALYSIS.CONFIRMATION_DIALOG.TITLE' | translate }}</h6>
    <lib-button
      id="delete-report-close-button"
      class="d-flex justify-content-end"
      [size]="'custom'"
      [color]="'primary-link'"
      [faIcon]="'far fa-times'"
      (buttonClicked)="hideConfirmationPopup()" >
    </lib-button>
  </div>
  <div class="modal-body d-flex align-items-center justify-content-center">
    <div>
      <div class="text-primary">
        {{ 'DATA_STUDIO.DATA_ANALYSIS.CONFIRMATION_DIALOG.QUERY_PART_OF' | translate }} <strong>{{reports}}</strong> {{ 'DATA_STUDIO.DATA_ANALYSIS.CONFIRMATION_DIALOG.CANNOT_BE_DELETED' | translate }}
      </div>
      <div class="text-primary">
        {{ 'DATA_STUDIO.DATA_ANALYSIS.CONFIRMATION_DIALOG.TO_DELETE_IT' | translate }}
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <lib-button [label]="'BUTTONS.OK' | translate" (buttonClicked)="hideConfirmationPopup()"></lib-button>
  </div>
</ng-template>
